module.exports = __webpack_public_path__ + "static/media/gear-about-bg.dd15e36b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gear-about-bg.png
// module id = 311
// module chunks = 0